import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { XMLElementBaseComponent } from '../base';
import { QVChapter } from '../volkswagen.types';

/**
 * This compnent renders the chapter link in VW articles.
 * It not in use currently, but kept for future reference.
 */

@Component({
  selector: 'app-vw-qv-chapter',
  imports: [CommonModule, RouterLink],
  standalone: true,
  template: `
    @if (chapterText2()) {
      @if (data.ziel) {
        <a [routerLink]="[]" [queryParams]="linkParams()" class="text-blue-800 hover:underline">
          {{ chapterText2() }}
        </a>
        <br />
      } @else {
        <span>{{ chapterText2() }}</span>
      }
    }

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class QVChapterComponent extends XMLElementBaseComponent<QVChapter> {
  chapterText2 = computed(() => {
    const zielText = this.data?.['ziel'] ? ` ${this.data['ziel']}` : '';
    return this.getTitle(this.data.children) + zielText;
  });

  getTitle(tag: any) {
    const cleanUp = (text: any) => (!['“', '”', '"', '„', '“', '«', '»', "'", '‹', '›'].includes(text?.trim()) ? text?.trim() : '');

    let text = tag?.['text']?.trim();
    text = cleanUp(text);

    if (Array.isArray(tag)) {
      text = tag.map((t) => this.getTitle(t)).join(' ');
      return text;
    }

    if (tag['children'] && Array.isArray(tag['children'])) {
      const childrenText = tag['children'].map((child: any) => this.getTitle(child)).join(' ');
      text = [text, childrenText].join(' ');
    }
    return text.trim();
  }

  linkParams = computed(() => {
    return {
      type: 'vw',
      chapterId: this.data.ziel,
      articleView: 'true',
      provider: 'volkswagen',
    };
  });
}
